import { useEffect, useState } from "react";
import styles from "./CompanyProfile.module.css";
import useNotification from "../../../hooks/useNotification";
import React from "react";
import { ENTERPRISE, ENTERPRISE_COMPANY } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import { useLocation } from "react-router-dom";
import EnterpriseServices from "../../../services/EnterpriseServices";
import ProfilePage from "./ProfilePage";

const CompanyProfile = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const location = useLocation();

  const BreadcrumbOptions = [
    {
      title: "Enterprise",
      link: ENTERPRISE,
    },
    {
      title: data.company || "Company Name",
      link: ENTERPRISE_COMPANY + location?.pathname?.split("/")?.[3],
    },
    {
      title: "Profile edit",
    },
  ];

  useEffect(() => {
    const fetchUserOverviewData = async () => {
      const res = await EnterpriseServices.getJobById(
        location.pathname.split("/")[5]
      );

      if (res) {
        if (res.statusCode === 1) {
          setData(res.data);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
      setLoading(false);
    };
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <>
      <div className={styles.page_wrap}>
        <CustomBreadcrumb options={BreadcrumbOptions} />
        <ProfilePage />
      </div>
    </>
  );
};

export default CompanyProfile;
